<template>
  <v-row>
    <div
      v-if="description"
      v-html="description"
      class="description"
    />
    <ValidationProvider
      :name="field.name"
      slim
      mode="eager"
      :rules="rules"
      v-slot="{ errors }"
    >
      <v-autocomplete
        v-model="selectedId"
        :items="locations"
        :loading="loading"
        :search-input.sync="search"
        :label="`${placeholder} ${requiredHint}`"
        :error-messages="errors[0]"
        :no-data-text="$t('empty')"
        item-text="name"
        item-value="id"
        no-filter
      />
    </ValidationProvider>
  </v-row>
</template>

<script>
import _ from "lodash";
import {mapGetters} from "vuex";
import {BASE_API_URL} from "@/store";
import {getFieldRules} from "@/utils/auth/validation";

export default {
  name: "LocationField",
  props: {
    field: {
      type: Object,
      required: true
    },
    category: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedId: null,
      locations: [],
      loading: false,
      search: null
    };
  },
  computed: {
    ...mapGetters(["client_id"]),
    placeholder() {
      return this.field.placeholder ? this.$t(this.field.placeholder) : this.field.name;
    },
    requiredHint() {
      return this.field.required ? " *" : "";
    },
    rules() {
      return getFieldRules(this.field);
    },
    description() {
      const fieldDescription =
        _.get(this.field, "metadata.description", "") || _.get(this.field, "description", "");
      return _.isEmpty(fieldDescription) ? "" : fieldDescription;
    },
    selectedLocationName() {
      const selected = this.locations.find((l) => l.id === this.selectedId);
      return selected ? selected.name : null;
    }
  },
  watch: {
    search(val) {
      if (val === this.selectedLocationName) {
        this.debouncedFetchLocations("");
      } else {
        this.debouncedFetchLocations(val || "");
      }
    },
    selectedId(newVal) {
      this.$emit("select", {
        key: this.field.key,
        value: newVal,
        identity: this.field.identity ? this.field.identity : false
      });
    }
  },
  async created() {
    this.debouncedFetchLocations = _.debounce(this.fetchLocations, 200);
    await this.fetchLocations();
  },
  methods: {
    buildParams(search) {
      const params = {limit: 20};
      if (search) { params.search = search; }
      if (this.category) { params.category = this.category; }
      return params;
    },
    async fetchLocations(search) {
      this.loading = true;
      try {
        const response = await this.axios.get(
          `${BASE_API_URL}/api/v1/clients/${this.client_id}/locations/`,
          {params: this.buildParams(search)}
        );
        const raw = _.get(response, "data.results", response.data);
        const results = Array.isArray(raw) ? raw : [];

        if (this.selectedId && !results.some((l) => l.id === this.selectedId)) {
          const cached = this.locations.find((l) => l.id === this.selectedId);
          this.locations = cached ? [cached, ...results] : results;
        } else {
          this.locations = results;
        }
      } catch {
        this.locations = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
